import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, totalSteps }) => {
  return (
    <View style={styles.container}>
      <View style={styles.stepsContainer}>
        {Array.from({ length: totalSteps }, (_, index) => (
          <React.Fragment key={index}>
            <View
              style={[
                styles.step,
                index <= currentStep && styles.stepActive,
                index < currentStep && styles.stepCompleted,
              ]}
            >
              <Text
                style={[
                  styles.stepText,
                  index <= currentStep && styles.stepTextActive,
                ]}
              >
                {index + 1}
              </Text>
            </View>
            {index < totalSteps - 1 && (
              <View
                style={[
                  styles.line,
                  index < currentStep && styles.lineActive,
                ]}
              />
            )}
          </React.Fragment>
        ))}
      </View>
      <Text style={styles.label}>
        Step {currentStep + 1} of {totalSteps}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 14,
    paddingTop: 8,
    paddingBottom: 4,
    alignItems: 'center',
  },
  stepsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  step: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: '#E0E0E0',
    justifyContent: 'center',
    alignItems: 'center',
  },
  stepActive: {
    backgroundColor: '#3C8248',
  },
  stepCompleted: {
    backgroundColor: '#5B8C5A',
  },
  stepText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#999',
  },
  stepTextActive: {
    color: '#fff',
  },
  line: {
    width: 34,
    height: 3,
    backgroundColor: '#E0E0E0',
    marginHorizontal: 4,
  },
  lineActive: {
    backgroundColor: '#5B8C5A',
  },
  label: {
    fontSize: 11,
    color: '#64748B',
    fontWeight: '500',
  },
});

export default StepIndicator;

